import { DOCS_FORM_NAMES } from "core/consts";
import {
  DRG_CODE_CHARACTER_LIMIT,
  ICD_CODE_CHARACTER_LIMIT,
  IK_NUMBER_CHARACTER_LIMIT,
  INFECTIONS_CHARACTER_LIMIT,
  PENSION_INSURANCE_NUMBER_CHARACTER_LIMIT,
} from "core/schemas/shared";
import { importAuctionToDRVMedicalForm } from "dsl/ecosystems/PatientForms/RehabForms/DRVMedicalForm/importAuction";
import { FormFieldConfigFactory } from "..";
import { DRVMedicalFormSchema } from "./schema";
import { DRVMedicalFormSections } from "./sections";

export const getDRVMedicalFormConfig: FormFieldConfigFactory<
  typeof DOCS_FORM_NAMES.DRV_MEDICAL
> = () => {
  return {
    auctionToForm: importAuctionToDRVMedicalForm,
    config: { canPrint: true, canSendToHis: true },
    getInitialValue: ({ value }) => {
      return {
        admission_date: value?.admission_date ?? undefined,
        carelevel: value?.carelevel ?? undefined,
        carelevel_selected: value?.carelevel_selected ?? undefined,
        clinical_findings: value?.clinical_findings ?? "",
        complications: value?.complications ?? "",
        current_therapy: value?.current_therapy ?? "",
        day_reha: value?.day_reha ?? false,
        discharge_date: value?.discharge_date ?? undefined,
        drg_code: value?.drg_code?.slice(0, DRG_CODE_CHARACTER_LIMIT) ?? "",
        drv_remarks: value?.drv_remarks ?? "",
        eat_without_help: value?.eat_without_help ?? undefined,
        fecal_incontinence: value?.fecal_incontinence ?? undefined,
        full_reha: value?.full_reha ?? false,
        further_therapeutic_diagnostic_measures_description:
          value?.further_therapeutic_diagnostic_measures_description ?? "",
        further_therapeutic_diagnostic_measures_finished_on:
          value?.further_therapeutic_diagnostic_measures_finished_on ??
          undefined,
        further_therapeutic_diagnostic_measures_from:
          value?.further_therapeutic_diagnostic_measures_from ?? undefined,
        further_therapeutic_diagnostic_measures_to:
          value?.further_therapeutic_diagnostic_measures_to ?? undefined,
        hospital_bank_holder: value?.hospital_bank_holder ?? "",
        hospital_bank_name: value?.hospital_bank_name ?? "",
        hospital_billing_address: value?.hospital_billing_address ?? "",
        hospital_iban: value?.hospital_iban ?? "",
        hospital_ik_number:
          value?.hospital_ik_number?.slice(0, IK_NUMBER_CHARACTER_LIMIT) ?? "",
        hospital_name_address: value?.hospital_name_address ?? "",
        icd_code_1_code:
          value?.icd_code_1_code?.slice(0, ICD_CODE_CHARACTER_LIMIT) ?? "",
        icd_code_2_code:
          value?.icd_code_2_code?.slice(0, ICD_CODE_CHARACTER_LIMIT) ?? "",
        icd_code_3_code:
          value?.icd_code_3_code?.slice(0, ICD_CODE_CHARACTER_LIMIT) ?? "",
        infections:
          value?.infections?.slice(0, INFECTIONS_CHARACTER_LIMIT) ?? "",
        infections_selected: value?.infections_selected ?? undefined,
        insurance_delivery_address: value?.insurance_delivery_address ?? "",
        main_diagnosis: value?.main_diagnosis ?? "",
        mobility_walk_without_help:
          value?.mobility_walk_without_help ?? undefined,
        mobility_wheel_chair: value?.mobility_wheel_chair ?? undefined,
        needs_catheter: value?.needs_catheter ?? "",
        needs_catheter_selected: value?.needs_catheter_selected ?? undefined,
        orientation_disoriented: value?.orientation_disoriented ?? "",
        orientation_disoriented_selected:
          value?.orientation_disoriented_selected ?? undefined,
        other_measures: value?.other_measures ?? undefined,
        outpatient_not_possible_reason:
          value?.outpatient_not_possible_reason ?? undefined,
        patient_birthdate: value?.patient_birthdate ?? undefined,
        patient_city: value?.patient_city ?? "",
        patient_height: value?.patient_height ?? "",
        patient_name: value?.patient_name ?? "",
        patient_street_housenumber: value?.patient_street_housenumber ?? "",
        patient_weight: value?.patient_weight ?? "",
        patient_zipcode: value?.patient_zipcode ?? "",
        pension_procedure_after_examination:
          value?.pension_procedure_after_examination ?? false,
        pension_procedure_direct: value?.pension_procedure_direct ?? false,
        preferred_rehab_clinic: value?.preferred_rehab_clinic ?? "",
        rehab_triggering_event: value?.rehab_triggering_event ?? undefined,
        rehab_triggering_event_date:
          value?.rehab_triggering_event_date ?? undefined,
        secondary_diagnosis: value?.secondary_diagnosis ?? "",
        secondary_diagnosis_selected:
          value?.secondary_diagnosis_selected ?? undefined,
        social_worker_name_number: value?.social_worker_name_number ?? "",
        statutory_pension_insurance_number:
          value?.statutory_pension_insurance_number?.slice(
            0,
            PENSION_INSURANCE_NUMBER_CHARACTER_LIMIT,
          ) ?? "",
        transfer_date: value?.transfer_date ?? undefined,
        transport_type: value?.transport_type ?? undefined,
        urinary_incontinence: value?.urinary_incontinence ?? undefined,
        wash_and_dress_without_help:
          value?.wash_and_dress_without_help ?? undefined,
        wound_closed: value?.wound_closed ?? undefined,
      };
    },
    header: ({ translations }) =>
      translations.patientForms.drvMedicalForm.title,
    schema: DRVMedicalFormSchema,
    sections: DRVMedicalFormSections,
  };
};
